import { Component, OnInit, ViewChild } from '@angular/core';
import {Router} from '@angular/router';
import {ApikeysService} from '../../../apikeys/apikeys.service';
import {MatDialog} from '@angular/material/dialog';
import {PageHeaderDataService} from '../../../../../shared/services/page-header-data.service';
import {FormBuilder} from '@angular/forms';
import {VentasComercioService} from '../ventas-comercio.service';
import {PageHeaderData} from '../../../../../shared/components/forms-header/page-header-data';
import {Apikeys} from '../../../../../_models/apikeys';
import {Subject} from 'rxjs';
import {SolicitudCreditoService} from "../../../../entidad/solicitud-credito/solicitud-credito.service";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {takeUntil} from "rxjs/operators";
import {MatDatepicker} from "@angular/material/datepicker/datepicker";
import {VentasComercio} from "../../../../../_models/ventas-comercio";
import {HistoricoCompraComponent} from "../historico-compra/historico-compra.component";
import {DatosCompraComponent} from "../datos-compra/datos-compra.component";
import {SnackbarService} from "../../../../../services/snackbar-service.service";
import {JsonCsvService} from "../../../../entidad/reporte/json-csv.service";

@Component({
  selector: 'app-list-ventas-comercio',
  templateUrl: './list-ventas-comercio.component.html',
  styleUrls: ['./list-ventas-comercio.component.scss']
})
export class ListVentasComercioComponent implements OnInit {
  displayedColumns = ['fechaHora','nombre','apellido', 'nroSolicitud', 'estadoSolicitud', 'importe', 'comercio', 'acciones'];
  dataSource: Array<VentasComercio> = [];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  estadoList: any[] = [];
  comercioList: any[] = [];
  filter: any = {
    nombre: '',
    apellido: '',
    comercio: '',
    estadoSolicitudId: '',
    fechaCompra: '',
    entidad: false,
    cantidadPagina: 10,
    pagina: 1
  };
  panelOpenState = true; // muestra/oculta el filtro
  paginacion: any = {
    cantidad: 0,
    por_pagina: 10,
    pagina: 1,
    total: 0,
  };
  filterTimer: any;
  formFilter = null;
  unsubscribe$: Subject<any> = new Subject();

  constructor(
    public router: Router,
    public service: VentasComercioService,
    private solicitudCreditoService: SolicitudCreditoService,
    public dialog: MatDialog,
    private headerDataService: PageHeaderDataService,
    private fb: FormBuilder,
    private snackbar: SnackbarService,
    private csvService: JsonCsvService,
  ) {
    this.buildForm();
  }

  ngOnInit(): void {
    if (this.router.url ===  '/procesadora/ventas') {
      this.headerDataService.setHeaderData(new PageHeaderData('Ventas Realizadas', 'procesadora/ventas', false, false));
      this.filter.entidad = false; // no filtra por entidad
    }

    if (this.router.url ===  '/entidad/ventas') {
      this.headerDataService.setHeaderData(new PageHeaderData('Ventas Realizadas', 'entidad/ventas', false, false));
      this.filter.entidad = true; // filtra por entidad
    }

    this.obtenerListaEstadoSolicitudCredito();
    this.obtenerListaComercio();
    this.obtenerListaVentaComercio();
  }

  private buildForm() {
    this.formFilter = this.fb.group({
      nombre: [''],
      apellido: [''],
      comercio: [''],
      estadoSolicitudId: [''],
      fechaCompra: [''],
    });
    // se enlazan filtros con formulario reactivo
    this.formFilter.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe( data => {
      clearTimeout(this.filterTimer);
      this.filterTimer = setTimeout(() => {

        let fechaHora: Date;
        let fFechaHora = '';

        if (data.fechaCompra) {
          fechaHora = new Date(data.fechaCompra);
          fFechaHora = (fechaHora.getMonth() < 9 ? '0' : '-') + (fechaHora.getMonth()+1) + (fechaHora.getDate() < 10 ? '-0' : '-')  + fechaHora.getDate() +'-'+ fechaHora.getFullYear();
        }

        this.filter.nombre = data.nombre;
        this.filter.apellido = data.apellido;
        this.filter.comercio = data.comercio;
        this.filter.estadoSolicitudId = data.estadoSolicitudId === 'TODOS' ? '' : data.estadoSolicitudId;
        this.filter.fechaCompra = fFechaHora;
        this.paginator.firstPage();
        this.obtenerListaVentaComercio();
        clearTimeout(this.filterTimer);
      }, 500);
    });
  }

  /**
   * Funcion para obtener la lista de estados de solicitudes de crédito existentes
   */
  obtenerListaEstadoSolicitudCredito() {
    this.solicitudCreditoService.obtenerListaEstaddoSolicitudCredito()
      .subscribe(
        data => {
          if (data != null && data['data'] != undefined) {
            this.estadoList = [...[{id: '', nombre: 'TODOS'}], ...data['data']];
          } else {
            this.estadoList = [];
          }
          //this.snackbar.noMessage();
        });
  }

  /**
   * Funcion para obtener la lista de comercio
   */
  obtenerListaComercio() {
    this.service.obtenerListaComercio()
      .subscribe(
        data => {
          if (data != null && data['data'] != undefined) {
            this.comercioList = [...[{id: '', nombre_fantasia: 'TODOS'}], ...data['data']];
          } else {
            this.comercioList = [];
          }
          //this.snackbar.noMessage();
        });
  }
  /**
   * Funcion para obtener la lista de ventas del comercio
   */
  obtenerListaVentaComercio() {
    this.service.obtenerListaVenta(this.filter)
      .subscribe(
        data => {
          if (data != null && data['data'] != undefined) {
            this.dataSource = data['data'] as any[];
            if (data['pagination']) {
              this.paginacion.actual = +data['pagination']['actual'];
              this.paginacion.cantidad = +data['pagination']['cantidad'];
              this.paginacion.por_pagina = +data['pagination']['por_pagina'];
              this.paginacion.total = +data['pagination']['total'];
            }
          } else {
            this.dataSource = [];
            this.paginacion = {
              actual: 1,
              cantidad: 1,
              por_pagina: 10,
              total: 1
            };
          }
          //this.snackbar.noMessage();
        });
  }

  public obtenerDatos(event?: PageEvent) {
    let pagina = 1;
    pagina = event.pageIndex + 1;
    if (event.pageIndex === 0 && event.previousPageIndex === 1) {
      pagina = 1;
    }
    this.filter.cantidadPagina = event.pageSize;
    this.filter.pagina = pagina;
    this.obtenerListaVentaComercio();
    return event;
  }

  /**
   * Limpia campos de fehca
   * @param campo nombre del filtro a limpiar
   * @param $event componente a limpiar en el html
   */
  clearDate(campo: string, $event: MatDatepicker<any>) {
    this.filter[campo] = '';
  }



  openDialog(e: VentasComercio): void  {
    console.log('lista de compra')

    if (!e.carrito || e.carrito.length === 0) {
      this.snackbar.showMessage('El carrito no posee detalles', 'warning');
      return;
    }

    this.dialog.open(HistoricoCompraComponent, {
      data: e,
      panelClass: 'custom-dialog-container'
    });
  }

  openDialogDatos(e: VentasComercio) {
    console.log(e.carrito)
    if (!e.carrito || e.carrito.length === 0) {
      this.snackbar.showMessage('El carrito no posee detalles', 'warning');
      return;
    }
    e['cliente'] = e.nombre + ' ' + e.apellido
    this.dialog.open(DatosCompraComponent, {
      //height: '30%',
      width: '50%',
      data: e,
      panelClass: 'custom-dialog-container'
    });
  }

  exportar() {
    let fechaHora: Date;
    let fechaCompra = '';
    if(this.formFilter.controls.fechaCompra.value){
      fechaHora = new Date(this.formFilter.controls.fechaCompra.value);
      fechaCompra = (fechaHora.getMonth() < 9 ? '0' : '-') + (fechaHora.getMonth()+1) + (fechaHora.getDate() < 10 ? '-0' : '-')  + fechaHora.getDate() +'-'+ fechaHora.getFullYear();
    }


    const nombre =
      'reporte_ventas_' + fechaCompra;

    const data = {
      clienteNombre: this.filter.nombre,
      clienteApellido: this.filter.apellido,
      comercio: this.filter.comercio,
      estadoSolicitudId: this.filter.estadoSolicitudId,
      fechaCompra: fechaCompra,
      entidad: this.filter.entidad,
      cantidadPagina: this.filter.cantidadPagina,
      pagina: 0,
    };
    console.log(data);
    this.service.obtenerListaVentaExportar(data).subscribe((res: any) => {
      if (!(res instanceof Array)) {
        this.snackbar.showMessage(
          `Reporte generado, ${res.data.length} registros`,
          'success',
          2000
        );
        this.csvService.downloadFile(
          res.data,
          [
            'id',
            'fechaHora',
            'clienteNombre',
            'clienteApellido',
            'nroSolicitud',
            'estadoSolicitud',
            'importe',
            'comercio',
            'datosCompraEmail',
            'datosCompraNombre',
            'datosCompraApellido',
            'datosCompraCelularNro',
            'datosCompraDocumentoNro',
            'carritoComercioIdentificador',
            'carritoCodigo',
            'carritoDescripcion',
            'carritoCant',
            'carritoMonto',
          ],
          nombre
        );
      } else {
        this.snackbar.showMessage(
          'No se encontraron datos en el rango de fechas',
          'warning',
          2000
        );
      }
    });

  }
}
